import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { ContractSignatureType } from '../../../../../core';

@JsonConverter
export class ContractSignatureTypeAdapter implements JsonCustomConvert<ContractSignatureType | undefined> {
    serialize(type: ContractSignatureType): any | undefined {
        return type ? String(type) : undefined;
    }

    deserialize(type: any): ContractSignatureType | undefined {
        switch (type) {
            case 'individual_signature':
                return ContractSignatureType.SOLE;
            case 'joint_signature':
                return ContractSignatureType.JOINT;
            case 'conditional_joint_signature':
                return ContractSignatureType.CONDITIONAL_JOINT;
            default:
                return undefined;
        }
    }
}
